import { useContext, useEffect, useState } from "react";
import { Themes } from "../../enums/themes";
import Context from "./context";

export const Alert = () => {

    const [show, setShow] = useState(false);
    const [reveal, setReveal] = useState(false);
    const context = useContext(Context);

    useEffect(() => {
        if (context.alert.message) {
            setShow(true);
            setTimeout(() => {
                setReveal(true);
            }, 500);
        }
        setTimeout(() => {
            setReveal(false);
            setTimeout(() => {
                setShow(false);
            }, 1000);
        }, 5000);
      }, [context.alert]);

    return show ? (
        <div className={`fixed top-4 w-full container mx-auto border rounded-lg overflow-hidden p-4 transition-opacity ease-in duration-500 left-0 right-0 z-50 ${context.alert.theme} ${reveal ? 'opacity-100' : 'opacity-0'}`}>
            <span className="block">{context.alert.message}</span>
        </div>
    ) : null;
}

export interface IAlert {
    message: string,
    theme?: Themes
}